import React, { useState , useRef } from "react";
import "../Category2/Roof_waterproofing_bituminous_sheets.css";
import { Link } from "react-router-dom";
import ContactSection2 from '../Category/ContactSection2';


export default function Work_at_Height_Training() {


  return (

    <div className="Roof_waterproofing_bituminous_sheets-page">
      <div className="Roof_waterproofing_bituminous_sheets-hero">
        <div className="Roof_waterproofing_bituminous_sheets-overlay">
          <h1>          הדרכות עבודה בגובה </h1>
        </div>
<div>
</div>
</div>
    <div className="page6">
 <div className="breadcrumb6">
  <Link to="/">בית</Link> /{" "}
   <Link to="/Work_at_Height_Training">    הדרכות עבודה בגובה   </Link>{" "}
</div>
    </div>

      {/* CONTENT */}
<div className="page6">
  <div className="container">

    <div className="content-row2">



      <div className="text-box">
<p>
מי מבצע הדרכות עבודה בגובה? האם אתם יכולים להדריך את העובדים שלכם בעצמכם או שחובה לבצע את ההדרכה באמצעות גורם מוסמך ומורשה? כל כמה זמן יש לבצע הדרכה ומה היא צריכה לכלול? כל התשובות לכל השאלות, בשורות הבאות.



</p>

  <h2 className="info-title">   האם אפשר לבצע הדרכות עבודה בגובה באופן עצמאי?




</h2>


<p>

ובכן, התשובה היא כן ולא. ישנן הדרכות עבודה בגובה שאותן חייבים העובדים שלכם לעבור בליווי מדריך מקצועי. את ההדרכות הללו אין צורך לעבור בתדירות גבוהה ואפשר לעבור אותן תחילה בכדי להכשיר את העובד לעבודה בגובה ולאחר מכן בתדירות מסוימת שתבטיח את ריענון הידע הנדרש בקרב העובדים. מצד שני, את ההדרכות האלה אתם גם לא יכולים בשום פנים ואופן לבצע בעצמכם. המדובר בהדרכות מקצועיות המבוססות על מערכי שיעור מקצועיים וכוללות סט שלם של פריטי מידע שחייבים להיות מועברים למודרכים, ממש כמו רשימת מכולת.



</p>

<p>

לצד הדרכות אלה, ישנן הדרכות נקודתיות שאותן אתם בהחלט יכולים לבצע בעצמכם, ובלבד שאתם מוודאים שאתם אכן אומרים את הדברים הנכונים ושההדרכות שלכם עולות בקנה אחד עם המידע המקצועי הנדרש. הדרכות אלה יכולות להינתן אחת לשבוע או שבועיים לפני שעולים לגובה והן מיועדות בעיקר להעלאת המודעות ובכדי להזכיר לעובדים שגם אם ההדרכה המקצועית האחרונה שהם עברו, נערכה לפני שנה, שום דבר לא השתנה ביחס לחשיבות הדברים שנלמדו בה.


</p>





  <h2 className="info-title">  מיהו הגורם המוסמך והמורשה להעביר את ההדרכות?





</h2>
<p>

הדרכות עבודה בגובה הוא תחום שנמצא בפיקוח משרד העבודה, והוא הגורם שקובע מהם הנושאים שחייבים להיכלל בהדרכות הללו, מיהם העובדים שחייבים לעבור את ההדרכות ומתי וכן מיהו הגורם המורשה להעביר את ההדרכות וכיצד עליו להפוך למורשה. ככלל, במשרד העבודה ישנה רשימה של כל הגורמים המורשים להעברת הדרכות עבודה בגובה. גורמים אלה עברו תהליך הרשמה ככאלה מול משרד העבודה ומרגע שקיבלו את האישורים הנדרשים, הפכו להיות מורשים להעברת ההדרכות.

</p>

<p>

מומלץ לפנות לחברת המתמחה בתחום כמו עידן בגובה מדריך עבודה בגובה לתחום הבניין והתעשיה.
כאשר אתם רוצים להעביר הדרכה לעבודה בגובה עבור העובדים שלכם, תוכלו לאתר את הגורמים המורשים הללו, בין באמצעות כניסה לאתר משרד העבודה וצפייה ברשימת כל הגורמים ובין באמצעות חיפוש של גורם מורשה, ובמקרה זה יהיה עליכם לוודא שהגורם שמצהיר על עצמו כגורם מורשה להעברת הדרכות עבודה בגובה, הוא אכן כזה.
</p>


  <h2 className="info-title">  
כל כמה זמן צריך לבצע את ההדרכה?




</h2>



<p>

שאלה זו מתחברת שוב לנושא של מי מורשה להעביר את ההדרכה. כאשר מדובר בהדרכות רשמיות שאותן חייב העובד לעבור לפני שהוא עולה לגובה, ההדרכה חייבת להיות מועברת על ידי גורם מורשה לפני שהעובד עולה לגובה בפעם הראשונה. מרגע זה, הדרכות כאלה יכולות להתבצע בכל תדירות שתבחרו ואותן תוכלו לבצע בעצמכם. אלו הן ההדרכות שמיועדות לשמור על להבת הבטיחות בוערת, לשמר את המודעות ולהזכיר לעובדים את הסיכון שבתוכו הם עובדים. 


</p>





      </div>

    </div>





    <ContactSection2/>
<div className="links2">


  <Link to="/Choosing_a_company_for_abseiling_work" className="link-right" >  בחירת חברה לעבודות סנפלינג  </Link>
  <Link to="/Polyurethane_sealant" className="link-left" >   איטום בפוליאוריטן - כל מה שצריך לדעת   </Link>


</div>

      </div>
    </div>
  

      </div>
  );
}


